import React, { useState } from 'react'
import { SearchContext } from './SearchContext'

const SearchProvider = ({ children }) => {
    const [searchText, setSearchText] = useState("");
    
    const contextValue = {
        data: searchText,
        updateData: setSearchText
    }

    return <SearchContext.Provider value={contextValue}>
        {children}
    </SearchContext.Provider>
}

export default SearchProvider